import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faUser, faLock, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FaMicrosoft } from "react-icons/fa";
import { FaArrowAltCircleLeft } from "react-icons/fa";

const FirstLogin = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    digit: false,
    lowercase: false,
    uppercase: false,
    specialChar: false,
    length: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPasswordRequirements, setShowPasswordRequirements] =
    useState(false);

  const { token } = useParams();
  const navigate = useNavigate();
  const userRegex =
    /^(?=.*\d{1})(?=.*[a-z]{1})(?=.*[A-Z]{1})(?=.*[!@#$%^&*{|}?~_=+.-]{1})(?=.*[a-zA-Z0-9@$!%*?&{|}~_=+.-])(?!.*\s).{14,35}$/;

  useEffect(() => {
    fetch("http://localhost:8081/api/v1/auth/forgot-password/valid-op", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ encryptedData: token }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.length > 0) {
          setEmail(data[0].email);
        } else {
          setErrorMessage("No user found with the provided token.");
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
        setErrorMessage("There was a problem retrieving user information.");
      });
  }, [token]);

  const handlePasswordChange = (password) => {
    setPassword(password);
    setPasswordValidation({
      digit: /\d/.test(password),
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      specialChar: /[!@#$%^&*{|}?~_=+.-]/.test(password),
      length: password.length >= 14 && password.length <= 35,
    });
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleResetPassword = async (event) => {
   
    event.preventDefault();
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }

    if (
      !passwordValidation.digit ||
      !passwordValidation.lowercase ||
      !passwordValidation.uppercase ||
      !passwordValidation.specialChar ||
      !passwordValidation.length
    ) {
      setErrorMessage("Password does not meet the criteria");
      return;
    }
    try {
      const response = await fetch(
        "http://localhost:8081/api/v1/auth/createpassword",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.success) {
        setSuccessMessage(data.message);
        setErrorMessage("");
        toast.success(data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => {
          setLoading(true);
          localStorage.removeItem("accessToken");
          navigate("/");
          window.location.reload();
        }, 2000);
      } else {
        setErrorMessage(data.message);
        setSuccessMessage("");
        toast.error(data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      setErrorMessage("There was a problem with the reset operation");
      console.error("There was a problem with the reset operation:", error);
      toast.error("There was a problem with the reset operation", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="customize-container">
        <div className="customize-forms-container">
          <div className="customize-signin-signup">
            <form className="sign-in-form form" onSubmit={handleResetPassword}>
              <h2 className="customize-title">Create New Password</h2>
              <div className="customize-input-field">
                <FontAwesomeIcon icon={faLock} className=" mr-5" color="gray" />
                <input
                  id="password"
                  name="password"
                  placeholder="New Password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => handlePasswordChange(e.target.value)}
                  onBlur={() => setShowPasswordRequirements(true)}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  className="toggle-password-icon"
                  onClick={togglePasswordVisibility}
                />
              </div>
              <div>
                {showPasswordRequirements &&
                  (!passwordValidation.digit ||
                    !passwordValidation.lowercase ||
                    !passwordValidation.uppercase ||
                    !passwordValidation.specialChar ||
                    !passwordValidation.length) && (
                    <ul className="mt-2 text-left text-sm">
                      <li
                        style={{
                          color: passwordValidation.digit ? "green" : "red",
                        }}
                      >
                        At least one digit
                      </li>
                      <li
                        style={{
                          color: passwordValidation.lowercase ? "green" : "red",
                        }}
                      >
                        At least one lowercase letter
                      </li>
                      <li
                        style={{
                          color: passwordValidation.uppercase ? "green" : "red",
                        }}
                      >
                        At least one uppercase letter
                      </li>
                      <li
                        style={{
                          color: passwordValidation.specialChar
                            ? "green"
                            : "red",
                        }}
                      >
                        At least one special character (!@#$%^&*?~_=+.-)
                      </li>
                      <li
                        style={{
                          color: passwordValidation.length ? "green" : "red",
                        }}
                      >
                        Between 14 and 35 characters long
                      </li>
                    </ul>
                  )}
              </div>

              <div className="customize-input-field">
                <FontAwesomeIcon icon={faLock} className=" mr-5" color="gray" />
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEyeSlash : faEye}
                  className="toggle-password-icon"
                  onClick={toggleConfirmPasswordVisibility}
                />
              </div>
              <div>
                <button className="customize-btn solid" type="submit">
                  Create Password
                </button>
              </div>
              {errorMessage && (
                <p className="text-red-500 text-center mt-4">{errorMessage}</p>
              )}
              {successMessage && (
                <p className="text-green-500 text-center mt-4">
                  {successMessage}
                </p>
              )}
            </form>

            {loading && (
              <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50">
                <div
                  className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
                  style={{
                    borderTopColor: "white",
                    borderBottomColor: "white",
                  }}
                ></div>
                <p className="mt-4 text-white">
                  {" "}
                  The page will redirect to the login page. Please wait...
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <h1>DocBox</h1>
              <p>
                Streamlines file and folder management on computers or networks,
                boosting user efficiency and control over digital content
              </p>
            </div>

            <img src="/cloudbg.png" className="customize-image" alt="logo" />
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default FirstLogin;
